export default __webpack_public_path__ + "static/media/script_text.e95ac953.txt";